import { useState } from "react";
import * as appCrypt from "./crypt.js";
import axios from "axios";
import {LightAxios} from "./LightAxios";
const baseURL: string = process.env.REACT_APP_API_URL + '';
const appHost: string = process.env.REACT_APP_APP_HOST + '';
const appUpload: string = process.env.REACT_APP_APP_UPLOAD + '';

export function isOnline() {
	try {
		const check = window.localStorage.getItem("userOnline");
		if (typeof check === 'undefined')
			return false;
		// console.log('app key', process.env.REACT_APP_APP_KEY);
		// console.log('user online', check);
		let salt = process.env.REACT_APP_APP_KEY;
		salt = typeof salt === 'undefined' ? '' : salt;
		const result = (check != null && appCrypt.decryptData(check, salt))
			;
		// const result=(window.localStorage.getItem("userOnline") && appCrypt.decryptData(check, salt))?true:false;
		console.log('test result', result);
		return result;
	} catch (e) {
		console.log('not online:' + e);
		return false;
	}
};

export function getUser() {
	const aboutUser = appCrypt.decryptData(window.localStorage.getItem("aboutUser"), process.env.REACT_APP_APP_KEY);
	// console.log('my about', aboutUser);
	return aboutUser;
};

/**
 * get user information
 */
export function checkUser(userId: any) {
	axios.get(process.env.REACT_APP_API_URL + "users.php?id=" + userId)
		.then(response => {
			// console.log('debug',crypt.encryptData(response.id,process.env.APP_KEY));
			// window.localStorage.removeItem("aboutUser");
			// window.localStorage.removeItem("userOnline"); 
			// window.localStorage.setItem("userOnline", 
			// 	appCrypt.encryptData(response.id, process.env.REACT_APP_APP_KEY));
			window.localStorage.setItem("aboutUser",
				appCrypt.encryptData(response, process.env.REACT_APP_APP_KEY));
			//window.localStorage.setItem("SOME_CODE", crypt.encryptData({name: response.id},   myConst.APP_KEY));
			//navigate('/profile/');
			//window.location.reload();	
		})
}


// export const getUserData=()=>{
//         axios.post(baseURL+'getuserdata/',
//         {
//             header: localStorage.getItem("loginToken")
//         }).then((response:any)=>{
//             //console.log('user name',response.data.userName);
//             localStorage.setItem("userName", response.data.userName);
//             // setUserState({
//             // ...userState,
//             // userName: response.data.user.userName});
//         })
// }

export function sanitizeHtml(str: string) {
	let result: string = (str + ' ')
		.replaceAll('&amp;lt;', '&lt;')
		.replaceAll('&amp;gt;', '&gt;')
		.replaceAll('&lt;', '<')
		.replaceAll('&gt;', '>')
		.replaceAll('&nbsp;', ' ')
		.replaceAll('&amp;nbsp;', ' ')
		.replaceAll('&quot;', '"')


	// console.log(result.split('>'));
	let safeResult: string = '';

	//loop over all elements of the article
	result.split('>').forEach(element => {
		// console.log(element);
		//add your html element to parse here
		//testing if the element contains html tags, 
		//everything else shall not be rendered as html 
		if (element.indexOf("<div") >= 0
			|| element.indexOf("</div") >= 0
			|| element.indexOf("<br") >= 0
			|| element.indexOf("<p") >= 0
			|| element.indexOf("</p") >= 0
			|| element.indexOf("<img") >= 0
			|| element.indexOf("<a") >= 0
			|| element.indexOf("</a") >= 0
			|| element.indexOf("<h1") >= 0
			|| element.indexOf("</h1") >= 0
			|| element.indexOf("<h2") >= 0
			|| element.indexOf("</h2") >= 0
			|| element.indexOf("<h3") >= 0
			|| element.indexOf("</h3") >= 0
			|| element.indexOf("<h4") >= 0
			|| element.indexOf("</h4") >= 0
			|| element.indexOf("<h5") >= 0
			|| element.indexOf("</h5") >= 0
			|| element.indexOf("<h6") >= 0
			|| element.indexOf("</h6") >= 0
			|| element.indexOf("<strong") >= 0
			|| element.indexOf("</strong") >= 0
		) {
			element += '>';
			// console.log(element, 'is html indeed');
			//let myElem=document.createElement(element);
			//the following attribute sanitizing must me improved
			element = element.replaceAll('onClick', 'onClick_');
			element = element.replaceAll('onclick', 'onClick_');
			element = element.replaceAll('onMouseEnter', 'onMouseEnter_');
			element = element.replaceAll('onmouseEnter', 'onMouseEnter_');
			element = element.replaceAll('onmouseenter', 'onMouseEnter_');
			element = element.replaceAll('ondblclick', 'onDblclick_');
			element = element.replaceAll('href="javascript:', 'href="');
			//console.log('this is my element: ', element);
		} else {
			// console.log(element, 'is not hml');
			element += '>';
			element = element.replaceAll('<', '&lt;').replaceAll('>', '&gt;'); //should be replaced by &lt; or &gt;
		}

		//adding all the result to saferesult

		safeResult += element;

	});

	return safeResult;
}

export const getLastProfile = () => {
	axios.post(baseURL + 'getlastprofile/',
		{
			header: localStorage.getItem("loginToken")
		}).then((res: any) => {
			if (res.data.status === 'success') {
				/*setLastProfile({
					...lastProfile,
					src: res.data.file.src
				})*/
				localStorage.setItem('lastProfile', res.data.file.src);
				localStorage.setItem('userNumber', (res.data.user.number) + '');
			} else {

			}
		});
}

/**
 * 
 * translate string
 */
export const translate = (str: string) => {

	// axios.post(baseURL+'translate/', 
	// {
	// 	header: window.location, 
	// 	translate: str 
	// })
	// .then((res)=>{

	// })
	return str;
}

/**
* show sample pagination
*
*/
export const simplePagination = (articles: any) => {

}


/**simple toggle
*
*/
export const toggleState = (id: string) => {
	// const [settingsState, setSettingsState]:[any,any]=useState({
	//     id: ''
	// })
	// const changeEachSettingsState=(id:string)=>{
	//     setSettingsState((prev: any) => ({
	//         [id]: !prev[id]
	//     }))
	// }
}

export const getHost = () => {

	return process.env.REACT_APP_APP_HOST + '';
}

export const getBaseUrl = () => {
	return process.env.REACT_APP_API_URL + '';
}

export const getLightAxios=( )=>{
	return new LightAxios( );
}


export const getLogo =()=>{

	return `
  <?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   width="38px"
   height="50px"
   viewBox="0 0 38 50"
   version="1.1"
   id="SVGRoot"
   inkscape:version="0.92.4 (5da689c313, 2019-01-14)"
   sodipodi:docname="logoanimation1.svg">
  <defs
     id="defs1759">
    <linearGradient
       inkscape:collect="always"
       xlink:href="#linearGradient888"
       id="linearGradient1386"
       gradientUnits="userSpaceOnUse"
       x1="396.10544"
       y1="116.78759"
       x2="452.27621"
       y2="171.90956" />
    <linearGradient
       id="linearGradient888"
       inkscape:collect="always">
      <stop
         id="stop884"
         offset="0"
         style="stop-color:#000000;stop-opacity:1" />
      <stop
         id="stop886"
         offset="1"
         style="stop-color:#c02700;stop-opacity:0.99215686" />
    </linearGradient>
    <linearGradient
       inkscape:collect="always"
       xlink:href="#linearGradient1462"
       id="linearGradient1382"
       gradientUnits="userSpaceOnUse"
       x1="418.27844"
       y1="172.6615"
       x2="437.76468"
       y2="166.97174" />
    <linearGradient
       inkscape:collect="always"
       id="linearGradient1462">
      <stop
         style="stop-color:#a252da;stop-opacity:1;"
         offset="0"
         id="stop1458" />
      <stop
         style="stop-color:#a252da;stop-opacity:0;"
         offset="1"
         id="stop1460" />
    </linearGradient>
    <linearGradient
       inkscape:collect="always"
       xlink:href="#linearGradient888"
       id="linearGradient2383"
       gradientUnits="userSpaceOnUse"
       x1="396.10544"
       y1="116.78759"
       x2="452.27621"
       y2="171.90956" />
  </defs>
  <sodipodi:namedview
     id="base"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageopacity="0.0"
     inkscape:pageshadow="2"
     inkscape:zoom="9.5273335"
     inkscape:cx="19"
     inkscape:cy="25.305962"
     inkscape:document-units="px"
     inkscape:current-layer="layer1"
     showgrid="false"
     inkscape:window-width="1304"
     inkscape:window-height="745"
     inkscape:window-x="54"
     inkscape:window-y="-8"
     inkscape:window-maximized="1" />
  <metadata
     id="metadata1762">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <g
     inkscape:label="Calque 1"
     inkscape:groupmode="layer"
     id="layer1">
    <g
       id="g1643-3"
       style="fill:url(#linearGradient1386);fill-opacity:1"
       transform="matrix(0.57476836,0,0,0.54574398,662.13261,173.43397)"
       inkscape:export-filename="C:\Users\lumiere\Documents\Raising Connect Graphism\logoanimation\animation1.svg.png"
       inkscape:export-xdpi="43.199867"
       inkscape:export-ydpi="43.199867">
      <path
         sodipodi:nodetypes="ccccccccc"
         inkscape:connector-curvature="0"
         id="path7139-2-1"
         d="m -1120.6547,-274.35375 16.5791,21.85596 5.3868,-3.0307 -14.3945,-18.42837 c 41.4844,-21.84856 -8.3853,-55.97437 -25.6303,-25.9969 l 1.4987,74.30029 6.4082,-5.18291 -1.2451,-66.4152 c 9.1275,-21.86708 49.5095,2.04378 11.3971,22.89783 z"
         style="fill:#010101;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
      <g
         id="g1494-4-8"
         style="fill:url(#linearGradient2383);fill-opacity:1"
         transform="translate(-1534.8191,-416.74135)">
        <path
           style="fill:#010101;fill-opacity:1;stroke:none;stroke-width:1px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
           d="m 436.13033,161.21286 -21.89072,11.50666 -20.48746,-14.03251 -0.28065,-41.81687 22.17136,-8.86283 25.15034,7.76218 8.24651,-3.13106 -32.83555,-13.168601 -29.74891,12.629261 1.40325,52.48157 27.50371,16.55836 25.44077,-13.98833 z"
           id="path7137-95-3"
           inkscape:connector-curvature="0"
           sodipodi:nodetypes="ccccccccccccc" />
        <ellipse
           style="opacity:0.9729996;fill:#4e0b96;fill-opacity:1;stroke:none;stroke-width:33.61191177;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           id="ellipse7141-29-6"
           cx="415.59918"
           cy="124.33574"
           rx="10.746768"
           ry="11.120267" />
        <ellipse
           style="opacity:0.72000002;fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:6.66666651;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           id="path1452-6-1"
           cx="419.79724"
           cy="122.96722"
           rx="4.6406579"
           ry="5.2881918" />
        <path
           style="opacity:0.43200001;fill:url(#linearGradient1382);fill-opacity:1;stroke:none;stroke-width:1.33333325px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
           d="m 415.36219,181.13902 -1.1226,-8.4195 21.89072,-11.50666 4.67266,5.93783 z"
           id="path1456-2-8"
           inkscape:connector-curvature="0" />
      </g>
    </g>
  </g>
</svg>
`;

}